import Partner from "./_components/partner";

export default Partner;
